import $api from "@/core/services/ApiService";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import { ImportItem } from "@/core/services/api/interfaces/manager/ImportItem";

class ImportEndpoint {
  public list(params: AxiosRequestConfig = {}): Promise<AxiosResponse> {
    return $api.get("manager/imports", params);
  }

  public downloadOriginalFile(
    importItem: ImportItem,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.responseType = "blob";

    return $api.get(
      `manager/imports/${importItem.id}/downloads/original-file`,
      params
    );
  }

  public downloadErrorsFile(
    importItem: ImportItem,
    params: AxiosRequestConfig = {}
  ): Promise<AxiosResponse> {
    params.responseType = "blob";

    return $api.get(
      `manager/imports/${importItem.id}/downloads/errors-file`,
      params
    );
  }
}

export default ImportEndpoint;
